import type { TranslateFn, UploadFileRejection } from 'src/lib/pricelist-utils';
import { describeReceivedFileType } from 'src/lib/pricelist-utils';

/** Vendor price lists arrive as `.xlsx` or classic `.xls`. */
export const PRICE_LIST_BREAK_PIVOT_ACCEPT =
  '.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export function isPriceListBreakPivotExcelFile(file: File): boolean {
  return /\.(xlsx|xls)$/i.test(file.name);
}

export function validatePriceListBreakPivotFile(
  file: File,
  gt: TranslateFn,
): UploadFileRejection | null {
  if (isPriceListBreakPivotExcelFile(file)) return null;
  return {
    kind: 'unsupported',
    title: gt('Unsupported file format', {
      context: 'toast title when an unsupported file type is selected',
    }),
    message: `${gt('Got a file of type', {
      context:
        'prefix before the type of an unsupported file the user tried to upload',
    })} “${describeReceivedFileType(file)}”. ${gt(
      'Please upload a file ending in .xls or .xlsx.',
      {
        context:
          'toast message listing the supported price-list break pivot Excel formats',
      },
    )}`,
  };
}
